// see docs/EXTRACTED_COMMENTS.md#c006
export const CACHE_VERSION = 5;

export const SNAPSHOT_STORE = "snapshots";
export const SNAPSHOT_TTL_MS = 30 * 60 * 1000;


